module.exports = __webpack_public_path__ + "static/media/peace-and-justice.594c4215.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/peace-and-justice.jpg
// module id = 580
// module chunks = 0